import { useState } from 'react';
import ResponsiveTable from '../../../../shared/components/ResponsiveTable';
import { SortedColumn } from '../../../../shared/components/ResponsiveTable/models';
import {
  getBrowserTimezone,
  toPMIFormatDateWithTime,
} from '../../../../shared/helpers';
import { LogModel } from '../../models';
import BulkActionDetailsModal from '../BulkActionDetailsModal';
import { LogActionFormatter } from '../../LogActionFormatter';

export interface ChangeLogTableProps {
  logs: LogModel[];
}

const tableColumns = (
  onSeeMore: (log: LogModel, type: string) => void,
): SortedColumn[] => [
  {
    name: 'action',
    title: 'Action',
    cell: ({ row }) => (
      <LogActionFormatter
        onSeeMore={(type: string) => onSeeMore(row.original, type)}
        log={row.original}
      />
    ),
    width: 5,
    sortingEnabled: false,
  },
  {
    name: 'agreementID',
    title: 'Agreement ID',
    cell: (cntx) => (
      <span>
        {(
          cntx.row.original?.data?.agreementProviderId ??
          cntx.row.original?.data?.dealId
        )?.toString()}
      </span>
    ),

    width: 5,
    sortingEnabled: true,
  },
  {
    name: 'performedBy',
    title: 'Performed By',
    cell: (cntx) => (
      <span data-exclude-lg>{cntx.row.original?.performedBy?.personName}</span>
    ),
    width: 5,
    sortingEnabled: false,
  },
  {
    name: 'performedOn',
    title: `Date/Time (${getBrowserTimezone()})`,
    cell: (cntx) => {
      const formattedDate = cntx.row.original?.performedOn
        ? toPMIFormatDateWithTime(cntx.row.original.performedOn)
        : '';
      return (
        <div className={` fw-normal label`} data-testid="data-status">
          {formattedDate}
        </div>
      );
    },
    width: 10,
    sortingEnabled: false,
  },
];

export default function ChangeLogsTable({ logs }: ChangeLogTableProps) {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState<LogModel>(null);
  const [changeType, setChangeType] = useState<string>(null);
  return (
    <>
      <ResponsiveTable
        data={logs}
        columns={tableColumns((log, type: string) => {
          setShowModal(true);
          setModalData(log);
          setChangeType(type);
        })}
        onSort={() => {}}
      />
      {showModal && (
        <BulkActionDetailsModal
          log={modalData}
          type={changeType}
          onCancel={() => setShowModal(false)}
        />
      )}
    </>
  );
}
